import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __PRACTICE_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface ListTypeDocumentProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
}

const ListTypeDocumentComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
}: ListTypeDocumentProps): React.ReactElement => {
  const [documentCode] = useHttpFetch<HttpResponseList<string>, Array<ItemVM>>(
    `${__PRACTICE_API_URL__}/pratiche/tipo-operazione/codice-tipo-documento`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: (response: AxiosResponse<HttpResponseList<string>>) => {
        const { data } = response;
        return data?.payload?.list?.map((item) => ({
          id: item ? item.trim() : '',
          value: item ? item.trim() : '',
        }));
      },
    }
  );

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} id="type-label">
        {required ? 'Tipologia documento *' : 'Tipologia documento'}
      </InputLabel>
      <PmiSelect
        labelId="type-label"
        id="type-document"
        name="type-document"
        value={value}
        label={required ? 'Tipologia documento *' : 'Tipologia documento'}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(documentCode.data as Array<ItemVM>)?.map((element: ItemVM) => (
          <MenuItem key={element.id} value={element.value}>
            {element.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListTypeDocumentComponent.displayName = 'List type component';

const ListTypeDocument = memo(ListTypeDocumentComponent);

export default ListTypeDocument as typeof ListTypeDocumentComponent;
